import React, { useState, useMemo, useEffect, useCallback, useRef } from "react";
import clsx from "clsx";
import _ from "lodash";
import Tablenization from "@icoach/components/Tablenization";
import { memberSheet } from "@icoach/components/LabelBoxSheets";
import { Icons, Typography, Stack, Avatar, AvatarGroup, Tooltip, Button, Box } from "@curves/ui-base";
import useMemberCheckInApi from "@apis/useMemberCheckInApi";
import { parseDate } from "@util/moment";
import { isEqual } from "@util/utils";
import useSignalr from "@root/signalr/useSignalr";
import useLanding from "@icoach/landingPage/components/useLanding";

export const attentionArray = [
	{ id: 2 ** 0, Icon: Icons.Todo, title: "待辦事項" },
	{ id: 2 ** 1, Icon: Icons.Todo, title: "服銷待辦" },
	{ id: 2 ** 2, Icon: Icons.WorkoutGuide, title: "指導注意" },
	{ id: 2 ** 3, Icon: Icons.Dollar, title: "欠款", className: "bg-error-light" },
	{ id: 2 ** 4, Icon: Icons.Dollar, title: "信用卡號未填", className: "bg-error-light" },
	{ id: 2 ** 5, Icon: Icons.Dollar, title: "信用卡有效期限", className: "bg-error-light" },
	{ id: 2 ** 6, Icon: Icons.Dollar, title: "HC訂單欠款", className: "bg-error-light" },
	{ id: 2 ** 7, Icon: Icons.Dollar, title: "HC訂單信用卡有效期限", className: "bg-error-light" },
	{ id: 2 ** 8, Icon: Icons.Exclamations, title: "超危險", className: "bg-error-light" },
	{ id: 2 ** 9, Icon: Icons.Exclamation, title: "危險", className: "bg-info-light" },
	{ id: 2 ** 10, Icon: Icons.BirthdayCake, title: "當日壽星", className: "bg-error-light" },
	{ id: 2 ** 11, Icon: Icons.THundred, title: "百Ｔ資格", className: "bg-error-light" },
	{ id: 2 ** 12, Icon: Icons.Gift, title: "贈品待領取", className: "bg-info-light" },
	{ id: 2 ** 13, Icon: Icons.Renew, title: "會籍續約" },
	{ id: 2 ** 14, Icon: Icons.Leave, title: "會籍暫停中" },
	{ id: 2 ** 15, Icon: Icons.Consultation, title: "二周面談" },
	{ id: 2 ** 16, Icon: Icons.WeightReward, title: "量身提醒" },
	{ id: 2 ** 17, Icon: Icons.Gift, title: "30天新手禮物" },
	{ id: 2 ** 18, Icon: Icons.Gift, title: "90天新手禮物" },
	{ id: 2 ** 19, Icon: Icons.Gift, title: "點數贈品待領取" },
	{ id: 2 ** 20, Icon: Icons.Locker, title: "租櫃待續約" },
	{ id: 2 ** 21, Icon: Icons.Heart, title: "健康申告書" },
	{ id: 2 ** 22, Icon: Icons.Dollar, title: "智能訂單欠款", className: "bg-error-light" },
	{ id: 2 ** 23, Icon: Icons.Dollar, title: "智能訂單信用卡有效期限", className: "bg-error-light" },
];

export const popularizeArray = [
	{ id: 2 ** 0, Icon: Icons.WheyOrdered, title: "乳清訂購中" },
	{ id: 2 ** 1, Icon: Icons.ProbioticsOrdered, title: "益菌訂購中" },
	{ id: 2 ** 2, Icon: Icons.WheySuspended, title: "乳清暫停中" },
	{ id: 2 ** 3, Icon: Icons.ProbioticsSuspended, title: "益菌暫停中" },
	{ id: 2 ** 4, Icon: Icons.NoPushForMonths, title: "乳清未訂購(三個月不推)" },
	{ id: 2 ** 5, Icon: Icons.NoPushForMonths, title: "益菌未訂購(三個月不推)" },
	{ id: 2 ** 6, Icon: Icons.NoPushWhey, title: "永不推乳清" },
	{ id: 2 ** 7, Icon: Icons.NoPushProbiotics, title: "永不推益生菌" },
	{ id: 2 ** 10, Icon: Icons.CaOrdered, title: "鈣訂購中" },
	{ id: 2 ** 11, Icon: Icons.CaSuspended, title: "鈣暫停中" },
	{ id: 2 ** 12, Icon: Icons.NoPushForMonths, title: "鈣未訂購(三個月不推)" },
	{ id: 2 ** 13, Icon: Icons.CaNoPush, title: "永不推鈣" },
	// { id: 2 ** 14, Icon: , title: "鈣未訂購(可推)" }, 沒有對應圖示，沒有此狀態
	{ id: 2 ** 15, Icon: Icons.RingOrdered, title: "智能系統訂閱中" },
	{ id: 2 ** 16, Icon: Icons.RingSuspended, title: "智能系統暫停中" },
	// { id: 2 ** 17, Icon: , title: "智能系統未訂購" }, 沒有對應圖示，沒有此狀態
	{ id: 2 ** 18, Icon: Icons.RingNoPush, title: "永不推智能系統" },
];

const morePageProperty = {
	size: 50,
	latestID: 0,
};

/* 注意/訂單 icons  **/
const IconGroupLabel = props => {
	const { value: valueProps, iconArray: iconArrayProps = [], max: maxProps = 5 } = props;
	return (
		<Stack>
			<AvatarGroup
				isIcon={true}
				max={maxProps}
				componentsProps={{
					additionalAvatar: { style: { backgroundColor: "#000" } },
				}}
			>
				{Array.isArray(valueProps) &&
					valueProps.map(itemID => {
						const { id, Icon, title } = iconArrayProps.find(({ id }) => isEqual(id, itemID)) || {};
						if (id) {
							return (
								<Tooltip key={itemID} title={title} disableFocusListener>
									<Avatar className="line-height-1">
										<Icon />
									</Avatar>
								</Tooltip>
							);
						} else return null;
					})}
			</AvatarGroup>
		</Stack>
	);
};

/* 服銷待辦 **/
const ServiceSaleLabelSheet = props => {
	const { items = [] } = props;
	return <div className="text-ellipsis-columns-2">{Array.isArray(items) && items.map((target, _index) => <Typography key={`${target}_${_index}`}>{target}</Typography>)}</div>;
};

/* Table Label **/
const checkinLabel = [
	{
		cellKey: "checkinTime",
		headerLabel: "入場",
		align: "center",
		formatCell: (_value, _rowData) => {
			const order = _rowData["order"];
			return (
				<Stack direction="column" alignItems="center" className="checkin-table-checkin-time-label">
					<Box className="checkin-count">{order}</Box>
					{parseDate(_value, "HH:mm", false)}
				</Stack>
			);
		},
	},
	{ ...memberSheet, maxWidth: 20 },
	{
		cellKey: "measureDay",
		headerLabel: "WM日",
		align: "center",
		formatCell: (value, { isFinishSevenDay, isInterviewNotMeasure, isMonthMeasured, isNotify }) => {
			return (
				<Stack alignItems="center" justifyContent="center" spacing={1}>
					{isFinishSevenDay ? (
						<Tooltip title="七日內面談量身完成" disableFocusListener disableTouchListener>
							<Icons.Check fontSize="large" color="primary" />
						</Tooltip>
					) : (
						<Box className="pos-relative">
							{isInterviewNotMeasure ? (
								<React.Fragment>
									<Tooltip title="只面談不量身" disableFocusListener disableTouchListener>
										<Icons.DialogOutlined fontSize="large" htmlColor="#51a69e" />
									</Tooltip>
									<Typography color="gray" className="interview-not-measure" component="span">
										{value}
									</Typography>
								</React.Fragment>
							) : (
								<Typography color={isNotify && !isMonthMeasured ? "error" : "secondary"} className={clsx(isNotify && !isMonthMeasured && "font-weight-bold")} component="span">
									{value}
								</Typography>
							)}
						</Box>
					)}
					{isMonthMeasured ? (
						<Tooltip title="本月已量身或面談" disableFocusListener disableTouchListener>
							<Icons.Measuring color="primary" />
						</Tooltip>
					) : null}
				</Stack>
			);
		},
	},
	{
		cellKey: "workoutWeekCount",
		headerLabel: "本週WO",
		align: "center",
	},
	{
		cellKey: "workoutFrequency",
		headerLabel: "WO頻率",
		align: "center",
	},
	{
		cellKey: "workoutCount",
		headerLabel: "百T",
		align: "center",
		formatCell: (value, rowData) => {
			const modulo = value % 100;
			const ViewComp = modulo === 0 ? value : modulo >= 80 ? value : "";
			return ViewComp;
		},
	},
	{
		cellKey: "warinessTypes",
		headerLabel: "注意",
		align: "left",
		width: 11,
		formatCell: _value => <IconGroupLabel value={_value} iconArray={attentionArray} />,
	},
	{
		cellKey: "promotionTypes",
		headerLabel: "訂單狀態",
		align: "left",
		width: 8,
		formatCell: _value => {
			return <IconGroupLabel value={_value} iconArray={popularizeArray} max={3} />;
		},
	},
	{
		cellKey: "serviceSaleItems",
		headerLabel: "服銷待辦",
		align: "center",
		maxWidth: 12,
		formatCell: _value => {
			return <ServiceSaleLabelSheet items={_value} />;
		},
	},
];

const CheckinTable = props => {
	const signalr = useSignalr();
	const { dialogRef } = useLanding();
	const { getMemberCheckinApi } = useMemberCheckInApi();
	const rowLabel = useMemo(() => checkinLabel, []);
	const [rowsData, setRowsData] = useState([]);
	const morePageRef = useRef(0);

	/**
	 * 新增來店會員清單
	 */
	const addCheckin = _t => {
		setRowsData(pre => {
			const { memberID: addMemberID } = _t || {};
			// 去重：同一會員已在清單中（重複進場 / 訊息重送）就先移除舊資料，
			// 再把最新的放到最前面，避免出現重複列。
			const filtered = pre.filter(({ memberID: curMemberID }) => !isEqual(curMemberID, addMemberID));
			return [_t, ...filtered];
		});
	};

	/**
	 * 刷新來店會員清單  會有取不到state ***Allen 可教學用***
	 */
	const updateCheckin = resuorceData => {
		try {
			const { memberID: upDateMemberID } = resuorceData;
			setRowsData(prev => {
				let membersData = _.cloneDeep(prev);
				if (membersData.find(({ memberID: curMemberID }) => isEqual(curMemberID, upDateMemberID))) {
					membersData = membersData.map(memItem => {
						let newMemberData = memItem;
						if (isEqual(memItem.memberID, upDateMemberID)) {
							newMemberData = resuorceData;
						}
						return newMemberData;
					});
				} else {
					// 不在畫面的資料不會刷新
					// membersData.unshift(resuorceData);
				}
				return membersData;
			});
		} catch (error) {
			console.log(error);
		}
	};

	const handleRowOnClick = useCallback(
		({ memberID }) => {
			dialogRef.current.openMemberSummaryDialog({ memberID });
		},
		// eslint-disable-next-line
		[],
	);

	const handleMoreClick = () => {
		doCheckinDataApi();
	};

	// 判斷 row 是否要變色
	const handleRowClass = rowData => {
		const { warinessTypes = [] } = rowData;
		let classNames = "";
		// 判斷是有否交集
		const intersection = _.intersection(warinessTypes, cacheAttentionArray);
		const len = intersection.length;
		if (len) {
			const colorMap = intersection.reduce((acc, cur) => {
				let newAcc = { ...acc };
				const tarData = attentionArray.find(({ id }) => String(id) === String(cur));
				Object.assign(newAcc, { [tarData.className]: true });
				return newAcc;
			}, {});
			// 此處可與attentionArray className做變化 先不修改
			classNames = Object.keys(colorMap)[0];
		}
		return classNames;
	};

	/**
	 * 初始來店會員資料
	 */
	const doInitData = async () => {
		// 先掛上事件 handler 再 start，避免連線建立到掛上 handler 之間漏接訊息
		await signalr.on("CHECKIN_ADD", addCheckin);
		await signalr.on("CHECKIN_UPDATE", updateCheckin);
		// 斷線重連成功後，重新拉取清單補回斷線期間漏掉的進場事件
		signalr.onReconnected(reloadCheckinData);
		await signalr.start();
		await doCheckinDataApi();
	};

	/**
	 * 來店會員列表api
	 */
	const doCheckinDataApi = async () => {
		const resp = await getMemberCheckinApi({
			...morePageProperty,
			latestID: morePageRef.current,
		});
		if (resp) setRowsData(pre => [...pre, ...resp]);
	};

	/**
	 * 重新拉取來店會員列表（從第一頁開始，整個重置）
	 */
	const reloadCheckinData = async () => {
		morePageRef.current = 0;
		const resp = await getMemberCheckinApi({
			...morePageProperty,
			latestID: 0,
		});
		if (resp) setRowsData(resp);
	};

	// 暫存有className的變數
	const cacheAttentionArray = useMemo(
		() => {
			return attentionArray.reduce((acc, cur) => {
				if (cur.className) acc.push(cur.id);
				return acc;
			}, []);
		},
		// eslint-disable-next-line
		[],
	);

	/**
	 * 列表Comp
	 */
	const tableUseMemo = useMemo(
		() => {
			return (
				<Tablenization cardProps={{ square: true, isOverflowHidden: true }}>
					<Tablenization.TableRowHeader headerRow={rowLabel} className="checkin sticky-card-header" />
					<Tablenization.TableRowBody headerRow={rowLabel} rowsData={rowsData} rowOnClick={handleRowOnClick} bodyRowClass={{ fn: handleRowClass }} />
				</Tablenization>
			);
		},
		// eslint-disable-next-line
		[handleRowOnClick, rowLabel, rowsData],
	);

	/**
	 * 更多Comp
	 */
	const remaingingMemo = useMemo(
		() => {
			const { length } = rowsData;
			let isMore = false;
			if (!length) return null;
			else {
				const { order, memberID } = rowsData[length - 1];
				if (order > 1) {
					isMore = true;
					morePageRef.current = memberID;
				} else {
					morePageRef.current = 0;
				}
			}

			return (
				<React.Fragment>
					{isMore && (
						<Stack justifyContent="center" className="my-3">
							<Button onClick={handleMoreClick} fullWidth>
								更多
							</Button>
						</Stack>
					)}
				</React.Fragment>
			);
		},
		// eslint-disable-next-line
		[rowsData],
	);

	useEffect(
		() => {
			doInitData();
			return () => signalr.stop();
		},
		//eslint-disable-next-line
		[],
	);

	return (
		<Box>
			{tableUseMemo}
			{remaingingMemo}
		</Box>
	);
};

export default CheckinTable;
